import React from 'react';
import Complete from 'assets/images/content/app-accepted.png';

export const Finish = ({ closed }) => {
	return (
		<section className='login login_app  finish'>
			<div className='login__content'>
				<p className='login__info'>Спасибо! Ваша заявка принята.</p>
				<div className='login__img'>
					<picture>
						<img src={Complete} alt='Заявка принята' width='381' height='211' />
					</picture>
				</div>
                <button className="frame_btn button" onClick={closed}>
                    Закрыть
                </button>
			</div>
		</section>
	);
};
